import { v4 as uuidv4 } from 'uuid';
import { OptionList, OptionItem } from '@components/common/dropdown';
import type { MenuItem } from '@steadioTypes/dropdown';

type MenuProps = {
  menuList: MenuItem[];
  top: number;
};

export default function Menu({ menuList, top }: MenuProps) {
  return (
    <div
      className="absolute right-0 z-20 min-w-[204px]"
      style={{ top: `${top}px` }}
    >
      <OptionList>
        {menuList.map(({ onClick, content, mobileOnly }) => (
          <OptionItem
            key={uuidv4()}
            optionItem={{
              description: content,
              value: '',
            }}
            onOptionClick={onClick}
            lgHidden={mobileOnly}
          />
        ))}
      </OptionList>
    </div>
  );
}
